import { Route } from "react-router-dom";
import { lazy } from "react";
import ProtectedRoute from "../components/ProtectedRoute";

// Inventario
const DashboardInventory = lazy(() => import("../layouts/director/inventory/DashboardInventory"));

// Movimientos
const DashboardMovements = lazy(() => import("../layouts/director/movement/DashboardMovement"));

// Dispositivos
const DashboardRFID = lazy(() => import("../layouts/director/DashboardRFID"));

// Productos
const DashboardProducts = lazy(() => import("../layouts/director/product/DashboardProducts"));
const ProductDetails = lazy(() => import("../layouts/director/product/actions/ProductDetails"));

// Tiendas
const DashboardStores = lazy(() => import("../layouts/director/store/DashboardStore"));

// Proveedores
const DashboardSuppliers = lazy(() => import("../layouts/director/supplier/DashboardSupplier"));

// Clientes externos
const DashboardExternalClients = lazy(() => import("../layouts/director/externalClient/DashboardExternalClient"));

// Cambio de contraseña
const ChangePasswordFirstLogin = lazy(() => import("../layouts/password/ChangePasswordFirstLogin"));
const ChangePasswordLogged = lazy (() => import ("../layouts/password/ChangePasswordLogged"));

export default function SharedRoutes() {
  return (
    <>
      {/* INVENTARIO */}
      <Route
        path="/inventory"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR"]}>
            <DashboardInventory />
          </ProtectedRoute>
        }
      />

      {/* MOVIMIENTOS */}
      <Route
        path="/movement"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR"]}>
            <DashboardMovements />
          </ProtectedRoute>
        }
      />

      {/* DISPOSITIVOS */}
      <Route
        path="/devices"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR"]}>
            <DashboardRFID />
          </ProtectedRoute>
        }
      />

      {/* PRODUCTOS */}
      <Route
        path="/products"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR"]}>
            <DashboardProducts />
          </ProtectedRoute>
        }
      />
      <Route
        path="/products/view/:id"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR"]}>
            <ProductDetails />
          </ProtectedRoute>
        }
      />

      {/* TIENDAS */}
      <Route
        path="/stores"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR"]}>
            <DashboardStores />
          </ProtectedRoute>
        }
      />

      {/* PROVEEDORES */}
      <Route
        path="/supplier"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR"]}>
            <DashboardSuppliers />
          </ProtectedRoute>
        }
      />

      {/* CLIENTES EXTERNOS */}
      <Route
        path="/external-clients"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR"]}>
            <DashboardExternalClients />
          </ProtectedRoute>
        }
      />

      <Route
        path="/change-password"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR", "OPERATOR", "ADMIN"]}>
            <ChangePasswordFirstLogin />
          </ProtectedRoute>
        }
      />

      <Route
        path="/change-password-logged"
        element={
          <ProtectedRoute allowedRoles={["DIRECTOR", "SUPERVISOR", "OPERATOR", "ADMIN"]}>
            <ChangePasswordLogged />
          </ProtectedRoute>
        }
      />
    </>
  );
}
